import React, { Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';
import { TableDotIcon, TableSortControls } from 'components';
import { Warning as WarningIcon } from '@x5-react-uikit/icons';

type TProps = {
  onSortChange?: Dispatch<SetStateAction<Sorters>>;
  disableSorting?: boolean;
  sort?: Sorters;
};

const TableHeadGroup: React.FC<TProps> = ({
  onSortChange,
  disableSorting = false,
  sort,
}) => (
  <>
    <colgroup>
      <Box component="col" width="62px" /> {/* точка */}
      <Box component="col" width="auto" /> {/* ID списка */}
      <Box component="col" width="auto" /> {/* название файла */}
      <Box component="col" width="auto" /> {/* дата создания */}
      <Box component="col" width="100px" /> {/* дубликаты */}
      <Box component="col" width="auto" /> {/* файл разметки */}
      <Box component="col" width="88px" /> {/* кнопки для скачивания */}
      <Box component="col" width="78px" /> {/* ошибка */}
    </colgroup>
    <thead>
      <tr>
        <th>
          <TableDotIcon bgColor="#6c737d" ml={2} />
        </th>

        <th>ID списка</th>

        <th>название файла</th>

        <th>
          <TableSortControls
            disabled={disableSorting}
            onSortChange={onSortChange}
            filedName="createdAt"
            sort={sort}
          >
            дата создания
          </TableSortControls>
        </th>

        <th>дубликаты</th>

        <th>файл разметки</th>

        <th />

        <th>
          <WarningIcon />
        </th>
      </tr>
    </thead>
  </>
);

export default TableHeadGroup;
